import { formatAmount, normalizeAmount } from 'lib/utils/amount';

import Widget from 'services/widget/Widget';

class MessageWidget extends Widget {
  constructor(data) {
    super();

    this.code = data?.code || null;
    this.currency = data.currency;
    this.minDisplayAmount = formatAmount(data.minDisplayAmount, {
      significant_zeros: data.currency.significant_zeros,
      type: data.currency.type,
    });
    this.premiumDisplayAmount = formatAmount(data.premiumDisplayAmount, {
      significant_zeros: data.currency.significant_zeros,
      type: data.currency.type,
    });
    this.type = 'MESSAGE';
  }

  setData(data) {
    this.code = data.code;
    this.minDisplayAmount = formatAmount(data.minDisplayAmount, {
      significant_zeros: data.currency.significant_zeros,
      type: data.currency.type,
    });
    this.premiumDisplayAmount = formatAmount(data.premiumDisplayAmount, {
      significant_zeros: data.currency.significant_zeros,
      type: data.currency.type,
    });
  }

  isValidPremiumAmount() {
    return normalizeAmount(this.premiumDisplayAmount, this.currency) > normalizeAmount(this.minDisplayAmount, this.currency);
  }

  getData() {
    return {
      code: this.code,
      minDisplayAmount: normalizeAmount(this.minDisplayAmount, this.currency),
      premiumDisplayAmount: normalizeAmount(this.premiumDisplayAmount, this.currency),
      status: this.status,
      type: this.type,
    };
  }
}

export default MessageWidget;
